<template>
	<div  v-loading="loading">
		<el-select :class="{'input_w460': width == ''}" 
		:disabled="sel_disabled" :clearable="clearable" filterable  
		:style="`--width:` + width" @focus="firstClick"
			:multiple="multiple" collapse-tags  reserve-keyword  @change="selectChange"
			v-model="select_value" v-loadMore="loadMore" >
			<el-option v-for="(item, index) in select_list" :key="item.id" 
			:label="item.name" :value="item.id">
			</el-option>
		</el-select>
	</div>
</template>

<script>
	import {
		// 联系人列表
		lxrl_list_contact,
		// 客户列表
		kh_customer_list,
		// 成员列表
		get_membelist,
		
		get_project_list,
		
		xs_cue_pool_list,
	} from 'network/kh_public'
	import {
		getGoodsLis2,
	} from 'network/hk_goods'
	
	import {
		hkl_list_return,
		gchance_list,
		get_contracTlist,
	} from 'network/hk_operset'
	
	import {
		// 订单列表
		get_order_list,
	} from 'network/hk_order'
	
	import {
		get_quotation_list,
	} from 'network/hk_quotation'
	export default {
		name: 'newgratedropdown',
		props: {
			seltype: {  // 
				type: Number,
				default: 0,
			},
			width: {  //
				type: String,
				default: '',
			},
			// 自定义下拉列表
			customlist: {
				type: Object | Array,
				default: () => {
					return []
				},
			},
			// 默认设置的名称和id
			singleval: {
				type: Object,
				default: () => {
					return {}
				},
			},
			
			// 筛选列表的id
			screenid: {
				type: String | Number,
				default: '',
			},
			
			// 筛选列表的id
			screenstr: {
				type: String | Number,
				default: '',
			},
			

			clearable: {
				type: Boolean,
				default: true,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			multiple: {
				type: Boolean,
				default: false,
			},
			permit: {
				type: Boolean,
				default: true,
			},
			
		},
		watch: {
			disabled(){
				this.sel_disabled = JSON.parse(JSON.stringify(this.disabled))
			},
			search_name() {
				if (this.search_name == '') {
					if (this.seltype != 0) {
						this.fn_initial()
					} else {
						this.select_list = JSON.parse(JSON.stringify(this.selectOld_list))
					}
				}
			},
			screenid() {
				if(this.screenid) {
					this.select_value = ''
					this.select_list = []
					this.fn_initial()
				}
			},
			customlist(){
				this.setCreat()
			},
			singleval(){
				this.setCreat()
				
			},
			permit(){
				this.setCreat()
			},
		},
		created() {
			setTimeout(()=>{
				this.setCreat()
			}, 500)
		},
		data() {
			return {
				first_entry: false,
				select_list: [],
				selectOld_list: [],
				select_value: '',
		
				selectobj: {
					page: 1,
					pagesize: 20,
					last_page: 0,
				},
				search_name: '',
		
				loading: false,
		
				defdata: false,
		
				sel_disabled: false,
		
			}
		},
		methods: {
			firstClick(){
				if (!this.first_entry) return
				this.first_entry = false
				this.supervis_single() 
			},
			setCreat(){
				this.loading  = true
				if(!this.permit) {
					this.loading = false
				}
				this.select_value = ''
				this.select_list = []
				this.sel_disabled = JSON.parse(JSON.stringify(this.disabled))
				
				if (this.seltype == 0) { // 自定义下拉列表
					if (this.customlist && this.customlist.length) {
						this.select_list = JSON.parse(JSON.stringify(this.customlist))
						this.selectOld_list = JSON.parse(JSON.stringify(this.customlist))
					}
					if(this.multiple) {  // 多选
						this.select_value = this.singleval ? this.singleval.id : []
					}
					else {  // 单选
						this.select_value = this.singleval ? this.singleval.id : '';
					}
					this.loading = false;
				} else {
					// 单选下拉时，是否有默认数据
					
					this.supervis_single()
				}
			},
			
			supervis_single() {
				
				if(this.multiple) {  // 多选
					this.selectobj.pagesize = 999
					this.selectobj.page = 1
					this.getSelectList()
				}
				else {
					if (this.singleval && this.singleval.name) {
						let val = (this.singleval.name + '').trim()
						this.search_name = val
						this.defdata = true
					} else {
						this.defdata = false
					}
					this.fn_initial()
				}
				
			},
			// 输入内容搜索
			remoteMethod(query) {
				let value = (query + '').trim()
				this.search_name = value
				if (this.seltype != 0) {  // 接口查询
					this.select_list = []
					this.fn_initial()
				} else { // 模糊查询
					let resultList = [];
					this.selectOld_list.forEach((item) => {
						if (item.name.indexOf(value) > -1) {
							resultList.push(item);
						}
					});
					this.select_list = resultList
				}
			},
			// 下拉框 自定义事件，滚动条触底时触发 获取产品
			loadMore() {
				if (this.seltype != 0) {
					if (this.selectobj.page < this.selectobj.last_page) {
						this.selectobj.page += 1
						this.getSelectList()
					}
				}
			},
			// 获取下拉数据 
			getSelectList() {
				if(this.permit) {
					this.loading = true;
					let data = {
						sort_type: 1, // 排序类型
						pagesize: this.selectobj.pagesize, //  	
						page: this.selectobj.page,
						class_type: 0,
					}
					if (this.seltype == 1) { //客户
						this.getCustomerList(data)
					} 
					else if (this.seltype == 2) { // 联系人
						this.getContactslist(data)
					} 
					else if (this.seltype == 3) { // 成员
						this.getMembelist(data)
					}
					else if (this.seltype == 4) { // 产品
						this.getGoodsList(data)
					}
					else if (this.seltype == 5) { // 商机
						this.getChancelist(data)
					}
					else if (this.seltype == 6) { // 项目
						this.getProjectlist(data)
					}
					else if (this.seltype == 7) { // 合同
						this.getContractlist(data)
					}
					else if (this.seltype == 8) { // 回款
						this.getCollectionList(data)
					}
					else if (this.seltype == 9) { // 订单
						this.getOrderlist(data)
					}
					else if (this.seltype == 10) { // 报价单
						this.getQuotationlist(data)
					}
					else if (this.seltype == 11) { // 线索
						this.getcuelist(data)
					}
				}
			},
			// 线索列表
			getcuelist(data){
				if (this.search_name) {
					data.search_name = this.search_name
				}
				xs_cue_pool_list(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = res.result.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.id = item.cue_id || ''
									this.select_list.push(item)
								}
							} 
							this.handledata(obj.last_page)
						}
					}
				});
			},
			// 获取客户列表
			getCustomerList(data) {
				data.class_type = 0
				if (this.search_name) {
					data.search_type = 1
					data.search_name = this.search_name
				}
				kh_customer_list(data).then(res => {
					if (this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = res.result.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.name = item.customer_name || ''
									item.id = item.customer_id || ''
									this.select_list.push(item)
								}
							} 
							this.handledata(obj.last_page)
						}
					}
				})
			},
			// 获取联系人列表
			getContactslist(data) {
				if (this.screenid) {  // 列表筛选id
					data.customer_id = this.screenid
				}
				if (this.search_name) {
					data.search_type = 1
					data.search_name = this.search_name
				}
				lxrl_list_contact(data).then(res => {
					if (!this.$handlereq(res)) return
					let obj = res.result
					if (obj) {
						let list = res.result.data || [];
						if (list && list.length) {
							for (let item of list) {
								item.id = item.contact_id || ''
								this.select_list.push(item)
							}
						}
						let fliArr = list.filter(v=>v.is_main == 1)
						let defVal = fliArr[0] ? fliArr[0].contact_id : ''
						this.handledata(obj.last_page, defVal)
						
					}
				})
			},
			// 获取成员列表
			getMembelist(data) {
				if (this.search_name) {
					data.name = this.search_name
				}
				get_membelist(data).then(res => {
					if (this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = res.result.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.id = item.member_id || ''
									this.select_list.push(item)
								}
							}
							this.handledata(obj.last_page)
						}
					}
				})
			},
			// 获取产品列表 
			getGoodsList(data) {
				if (this.search_name) {
					data.name = this.search_name
				}
				getGoodsLis2(data).then(res => {
					if (this.$handlereq(res)) {
						let obj = res.result.goods
						if (obj) {
							let list = obj.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.id = item.goods_id || ''
									this.select_list.push(item)
								}
							}
							let total = obj ? obj.total : 0;
							let last_page = 1
							if (total > this.selectobj.pagesize) {
								last_page = Math.ceil(total / this.selectobj.pagesize)
							} 
							this.handledata(last_page)
						}
					}
				})
			},
			// 获取商机列表
			getChancelist(data) {
				data.is_recycle = 0
				if (this.search_name) {
					data.search_name = this.search_name
				}
				if (this.screenid) {  // 列表筛选id
					data.customer_id = this.screenid
				}
				gchance_list(data).then(res => {
					if (this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = obj.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.id = item.chance_id || '';
									this.select_list.push(item)
								}
							}
							this.handledata(obj.last_page)
						}
					}
				})
			},
			// 获取项目列表
			getProjectlist(data) {
				data.is_recycle = 0
				if (this.search_name) {
					data.search_name = this.search_name
				}
				if (this.screenid) {  // 列表筛选id
					data.customer_id = this.screenid
				}
				get_project_list(data).then(res => {
					if (this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = obj.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.id = item.project_id || '';
									this.select_list.push(item)
								}
							}
							this.handledata(obj.last_page)
						}
					}
				})
			},
			// 获取合同列表
			getContractlist(data) {
				data.is_recycle = 0
				if (this.search_name) {
					data.search_name = this.search_name
				}
				if (this.screenid) {  // 列表筛选id
					data.customer_id = this.screenid
				}
				get_contracTlist(data).then(res => {
					if (this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = obj.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.id = item.contract_id || '';
									this.select_list.push(item)
								}
							}
							this.handledata(obj.last_page)
						}
					}
				})
			},
			// 获取回款列表
			getCollectionList(data) {
				data.is_recycle = 0
				if (this.search_name) {
					data.search_name = this.search_name
				}
				if (this.screenid) {  // 列表筛选id
					data.customer_id = this.screenid
				}
				if (this.screenstr) {  // 列表筛选id
					data.return_id = this.screenstr
				}
				hkl_list_return(data).then(res => {
					if (this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = obj.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.name = `${item.hk_code}-${item.customer_name}`;
									item.id = item.return_id || '';
									this.select_list.push(item)
								}
							}
							this.handledata(obj.last_page)
						}
					}
				})
			},
			// 获取订单列表
			getOrderlist(data) {
				data.is_recycle = 0
				if (this.search_name) {
					data.search_name = this.search_name
				}
				if (this.screenid) {  // 列表筛选id
					data.customer_id = this.screenid
				}
				get_order_list(data).then(res => {
					if (this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = obj.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.name = `${item.dd_code}-${item.customer_name}`;
									item.id = item.order_id || '';
									this.select_list.push(item)
								}
							}
							this.handledata(obj.last_page)
						}
					}
				})
			},
			// 获取报价单列表
			getQuotationlist(data) {
				data.is_recycle = 0
				if (this.search_name) {
					data.search_name = this.search_name
				}
				if (this.screenid) {  // 列表筛选id
					data.customer_id = this.screenid
				}
				get_quotation_list(data).then(res => {
					if(this.$handlereq(res)) {
						let obj = res.result
						if (obj) {
							let list = obj.data || [];
							if (list && list.length) {
								for (let item of list) {
									item.name = `${item.bd_code}-${item.customer_name}`;
									item.id = item.quotation_id || '';
									this.select_list.push(item)
								}
							}
							this.handledata(obj.last_page)
						}
					}
				})
			},
			// 处理列表数据
			handledata(last_page, defVal) {
				if (this.defdata) { // 有默认数据
					this.defdata = false
					if(!this.sel_disabled) {
						this.search_name = ''
					}
					else {
						this.loading = false;
					}
					
				} else { // 没有默认数据
					this.selectobj.last_page = last_page || 0
					this.loading = false;
				}
				
				setTimeout(() => {
					if(this.multiple) {  // 多选
						this.select_value = this.singleval ? this.singleval.id : []
					}
					else {  // 单选
						this.select_value = this.singleval.id || this.singleval.name || '';
						if(defVal){
							this.select_value = defVal
						}
					}
					if(this.seltype == 2){
						this.fn_outlet()
					}
					// 
				}, 350)
				// 去除重复的
				if(this.select_list.length) {
					this.select_list = this.noRepeat(this.select_list)
				}
				
				
			
			},
			// 去重复
			noRepeat(arr) {
				let newArr = []
				var obj = {};
				newArr = arr.reduce(function(item, next) {
					obj[next.id] ? '' : obj[next.id] = true && item.push(next);
					return item;
				}, []);
				return newArr
			},
			// 下拉数据改变
			selectChange(e) {
				this.fn_outlet()
			},
			// 输出选择内容
			fn_outlet() {
				let res = {
					id: this.select_value || '',
					name: '',
					seltype: this.seltype,
				}
				if(this.multiple) {  // 多选
					if (this.select_value && this.select_value.length) {
						let nArr = []
						for(let item of this.select_value) {
							let index = this.select_list.findIndex(v => v.id == item)
							if (index != -1 && this.select_list[index]) {
								let name = this.select_list[index].name
								nArr.push(name)
								
							}
						}
						if(nArr.length) {
							res.name = nArr.join(',')
						}
					}
				}
				else {  // 单选
					if (this.select_value) {
						let index = this.select_list.findIndex(v => v.id == this.select_value)
						if (index != -1 && this.select_list[index]) {
							let name = (this.select_list[index].name + '')
							if (this.seltype < 11 && this.seltype > 8) {
								let sile_name = ''
								for (let i = 0; i < name.length; i++) {
									if (name[i] == "-") {
										sile_name = name.slice(0, i)
									}
								}
								res.name = sile_name
							}
							else {
								res.name = name
							}
						}
					}
				}
				console.log(res,' res')
				this.$emit('outlet', res)
			},
			// 初始化
			fn_initial() {
				if (this.seltype != 0) {
					this.selectobj = {
						page: 1,
						pagesize: 20,
						last_page: 0,
					}
					this.getSelectList()
				}
			},
		},
		
		directives: { // 在组件中接受一个 directives 的选项
			loadMore: {
				inserted(el, binding) {
					const dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap'); // 获取下拉框元素
					dom.addEventListener('scroll', function() { // 监听元素触底
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				},
			},
		},
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-input {
		width: var(--width) !important;
	}
    .input_w460 {
	  width: 460px;
	  height: 32px;
	}

</style>